import { defineStore } from "pinia";
import { userStore } from "@/store/user.js";
import { getStore } from "@/util/store.js";
import { getWx } from "@/util/platform.js";

const STORE_NAME = "juziSend";

/**
 * 橘子平台消息发送。
 * 橘子侧边栏发送小程序消息时，必须携带小程序原始 ID。
 */
export const useJuziSendStore = defineStore(STORE_NAME, {
  actions: {
    /**
     * 发送橘子平台小程序消息。
     * @param {Object} sendParams 企业微信 sendChatMessage 所需的小程序消息参数
     * @param {Function} callback 消息发送结果回调
     */
    sendMiniprogramMessage(sendParams, callback) {
      const user = userStore();
      const officialAccountId =
        user.miniprogramOriginId ||
        getStore({ name: "miniprogramOriginId" }) ||
        "";
      const miniprogram = {
        ...sendParams.miniprogram,
        // 橘子平台要求传入小程序原始 ID。
        officialAccountId,
      };
      const juziSendParams = {
        ...sendParams,
        miniprogram,
      };
      const wx = getWx();

      wx.invoke("sendChatMessage", juziSendParams, callback);
    },
    /**
     * 发送橘子平台图片消息。
     * @param {Object} sendParams 企业微信 sendChatMessage 所需的图片消息参数
     * @param {Function} callback 消息发送结果回调
     */
    sendImageMessage(sendParams, callback) {
      const wx = getWx();

      wx.invoke("sendChatMessage", sendParams, callback);
    },
  },
});
